module.exports = __webpack_public_path__ + "static/media/whatsapp.ed39266c.svg";